// extracted by mini-css-extract-plugin
module.exports = {"error":"LocalAuth_error__2gOx4"};